const tables = [
  {
    name: "Number",
  },
  {
    name: "Supplier",
  },
  {
    name: "Date",
  },
  {
    name: "Due",
  },
  {
    name: "Status",
  },
  {
    name: "Total",
  },
  {
    name: "Action",
  },
];

export default tables;
